import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoreModule } from './core/core.module';

import { LoginComponent } from './user/containers/login/login.component';
import { UserModule } from './user/user.module';
import { MainComponent } from './core/containers/main/main.component';
import { DashboardComponent } from './dashboard/containers/dashboard/dashboard.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { AuthGuard } from './user/services/auth.guard';
import { CompanyComponent } from './user/containers/company/company.component';
import { UserComponent } from './user/containers/user/user.component';
import { CreateCompanyComponent } from './user/containers/create-company/create-company.component';
import { ComapnyListResolver } from './user/services/comapny-list.resolver';
import { CompanyDetailComponent } from './user/containers/company-detail/company-detail.component';
import { ComapnyDetailResolver } from './user/services/company-detail.resolver';
import { UserListResolver } from './user/services/user-list.resolver';
import { TariffComponent } from './user/containers/tariff/tariff.component';
import { TariffListResolver } from './user/services/tariff-list.resolver';
import { UserDetailComponent } from './user/containers/user-detail/user-detail.component';
import { UserDetailResolver } from './user/services/user-detail.resolver';
import { CreateUserComponent } from './user/containers/create-user/create-user.component';
import { ComapnyLookupResolver } from './user/services/company-lookup.resolver';
import { TariffDetailComponent } from './user/containers/tariff-detail/tariff-detail.component';
import { TariffDetailResolver } from './user/services/tariff-detail.resolver';
import { LiftComponent } from './lift/containers/lift/lift.component';
import { LiftModuleComponent } from './lift/containers/lift-module/lift-module.component';
import { LiftListResolver } from './lift/services/lift-list.resolver';
import { LiftDetailResolver } from './lift/services/lift-detail.resolver';
import { LiftModuleListResolver } from './lift/services/lift-module-list.resolver';
import { LiftDetailComponent } from './lift/containers/lift-detail/lift-detail.component';
import { LiftModuleDetailComponent } from './lift/containers/lift-module-detail/lift-module-detail.component';
import { LiftModuleDetailResolver } from './lift/services/lift-module-detail.resolver';
import { HistoryComponent } from './core/components/history/history.component';
import { HistoryResolver } from './core/services/history.resolver';
import { UserLiftPermissionComponent } from './user/containers/user-lift-permission/user-lift-permission.component';
import { UserLiftPermissionResolver } from './user/services/user-lift-permission.resolver';
import { CreateLiftModuleComponent } from './lift/containers/create-lift-module/create-lift-module.component';
import { LiftStateComponent } from './lift/containers/lift-state/lift-state.component';
import { LiftErrorComponent } from './lift/containers/lift-error/lift-error.component';
import { LiftModuleLookupResolver } from './lift/services/lift-module-lookup.resolver';
import { LiftEngineLookupResolver } from './lift/services/lift-engine-lookup.resolver';
import { LiftTypeLookupResolver } from './lift/services/lift-type-lookup.resolver';
import { CreateLiftComponent } from './lift/containers/create-lift/create-lift.component';
import { LiftPermissionResolver } from './lift/services/lift-permission.resolver';
import { CreateTariffComponent } from './user/containers/create-tariff/create-tariff.component';
import { BasicLookupComponent } from './core/components/basic-lookup/basic-lookup.component';
import { LookupListResolver } from './core/services/lookup-list.resolver';
import { LiftStateResolver } from './lift/services/lift-state.resolver';
import { LiftErrorResolver } from './lift/services/lift-error.resolver';
import { LiftErrorLookupResolver } from './lift/services/lift-error-lookup.resolver';
import { CreateBasicLookupComponent } from './core/containers/create-basic-lookup/create-basic-lookup.component';
import { BasicLookupDetailComponent } from './core/containers/basic-lookup-detail/basic-lookup-detail.component';
import { LookupDetailResolver } from './core/services/lookup-detail.resolver';
import { LiftRideComponent } from './lift/containers/lift-ride/lift-ride.component';
import { LiftParametersComponent } from './lift/containers/lift-parameters/lift-parameters.component';
import { LiftConsumptionComponent } from './lift/containers/lift-consumption/lift-consumption.component';
import { LiftTemperatureComponent } from './lift/containers/lift-temperature/lift-temperature.component';
import { LiftRideResolver } from './lift/services/list-ride.resolver';
import { LiftTemperatureResolver } from './lift/services/lift-temperature.resolver';
import { LiftBoardLookupResolver } from './lift/services/lift-board-lookup.resolver';
import { LiftParameterSettingsListResolver } from './lift/services/lift-parameter-settings-list.resolver';
import { LiftParameterSettingsComponent } from './lift/containers/lift-parameter-settings/lift-parameter-settings.component';
import { CreateLiftParameterSettingsComponent } from './lift/containers/create-lift-parameter-settings/create-lift-parameter-settings.component';
import { LiftParameterSettingsDetailComponent } from './lift/containers/lift-parameter-settings-detail/lift-parameter-settings-detail.component';
import { LiftParameterSettingsDetailResolver } from './lift/services/lift-parameter-settings-detail.resolver';
import { LiftBoardParameterComponent } from './lift/containers/lift-board-parameter/lift-board-parameter.component';
import { LiftBoardParameterListResolver } from './lift/services/lift-board-parameter-list.resolver';
import { CreateLiftBoardParameterComponent } from './lift/containers/create-lift-board-parameter/create-lift-board-parameter.component';
import { CreateLiftBoardParameterGroupComponent } from './lift/containers/create-lift-board-parameter-group/create-lift-board-parameter-group.component';
import { LiftBoardGroupLookupResolver } from './lift/services/lift-board-group-lookup.resolver';
import { LiftBoardParameterGroupDetailComponent } from './lift/containers/lift-board-parameter-group-detail/lift-board-parameter-group-detail.component';
import { LiftBoardParameterDetailResolver } from './lift/services/lift-board-parameter-group-detail.resolver';
import { LiftControllerComponent } from './lift/containers/lift-controller/lift-controller.component';
import { ComapnyDashboardResolver } from './user/services/company-dashboard.resolver';
import { LiftErrorDashboardResolver } from './lift/services/lift-error-dashboard.resolver';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        resolve: { lifts: LiftListResolver, errors: LiftErrorDashboardResolver, tariff: ComapnyDashboardResolver }
      },
      {
        path: 'company',
        component: CompanyComponent,
        resolve: { companies: ComapnyListResolver }
      },
      {
        path: 'user',
        component: UserComponent,
        resolve: { users: UserListResolver }
      },
      {
        path: 'tariff',
        component: TariffComponent,
        resolve: { tariffs: TariffListResolver }
      },
      {
        path: 'lift',
        component: LiftComponent,
        resolve: { lifts: LiftListResolver }
      },
      {
        path: 'lift-module',
        component: LiftModuleComponent,
        resolve: { liftModules: LiftModuleListResolver }
      },
      {
        path: 'lift-parameter-settings',
        component: LiftParameterSettingsComponent,
        resolve: { parameters: LiftParameterSettingsListResolver }
      },
      {
        path: 'lift-board-parameter',
        component: LiftBoardParameterComponent,
        resolve: {
          parameters: LiftBoardParameterListResolver,
          liftBoards: LiftBoardLookupResolver
        }
      },
      {
        path: 'lookup/:type',
        component: BasicLookupComponent,
        resolve: { lookupList: LookupListResolver }
      },
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'history/:id',
    component: HistoryComponent,
    outlet: 'history',
    resolve: {
      histories: HistoryResolver
    }
  },
  {
    path: 'create-company',
    component: CreateCompanyComponent,
    outlet: 'modal',
    resolve: {
      tariffs: TariffListResolver
    }
  },
  {
    path: 'company-detail/:id',
    component: CompanyDetailComponent,
    outlet: 'modal',
    resolve: {
      company: ComapnyDetailResolver,
      tariffs: TariffListResolver
    }
  },
  {
    path: 'create-user',
    component: CreateUserComponent,
    outlet: 'modal'
  },
  {
    path: 'user-detail/:id',
    component: UserDetailComponent,
    outlet: 'modal',
    resolve: {
      user: UserDetailResolver
    }
  },
  {
    path: 'user-lift-permission/:id/:loginId',
    component: UserLiftPermissionComponent,
    outlet: 'modal',
    resolve: {
      permissions: UserLiftPermissionResolver,
      user: UserDetailResolver
    }
  },
  {
    path: 'create-tariff',
    component: CreateTariffComponent,
    outlet: 'modal'
  },
  {
    path: 'tariff-detail/:id',
    component: TariffDetailComponent,
    outlet: 'modal',
    resolve: {
      tariff: TariffDetailResolver
    }
  },
  {
    path: 'create-lift',
    component: CreateLiftComponent,
    outlet: 'modal',
    resolve: {
      modules: LiftModuleLookupResolver,
      liftEngines: LiftEngineLookupResolver,
      liftTypes: LiftTypeLookupResolver,
      liftBoards: LiftBoardLookupResolver
    }
  },
  {
    path: 'lift-detail/:id',
    component: LiftDetailComponent,
    outlet: 'modal',
    resolve: {
      lift: LiftDetailResolver,
      modules: LiftModuleLookupResolver,
      liftEngines: LiftEngineLookupResolver,
      liftTypes: LiftTypeLookupResolver,
      liftPermission: LiftPermissionResolver,
      liftBoards: LiftBoardLookupResolver
    }
  },
  {
    path: 'lift-state/:id',
    component: LiftStateComponent,
    outlet: 'modal',
    resolve: {
      state: LiftStateResolver,
      lift: LiftDetailResolver,
      liftPermission: LiftPermissionResolver
    }
  },
  {
    path: 'lift-controller/:id',
    component: LiftControllerComponent,
    outlet: 'modal',
    resolve: {
      lift: LiftDetailResolver,
      liftPermission: LiftPermissionResolver
    }
  },
  {
    path: 'lift-error/:id',
    component: LiftErrorComponent,
    outlet: 'modal',
    resolve: {
      errors: LiftErrorResolver,
      lift: LiftDetailResolver,
      errorTypes: LiftErrorLookupResolver,
      liftPermission: LiftPermissionResolver,
    }
  },
  {
    path: 'lift-ride/:id',
    component: LiftRideComponent,
    outlet: 'modal',
    resolve: {
      lift: LiftDetailResolver,
      liftPermission: LiftPermissionResolver,
      rides: LiftRideResolver
    }
  },
  {
    path: 'lift-parameters/:id',
    component: LiftParametersComponent,
    outlet: 'modal',
    resolve: {
      lift: LiftDetailResolver,
      liftPermission: LiftPermissionResolver
    }
  },
  {
    path: 'lift-temperature/:id',
    component: LiftTemperatureComponent,
    outlet: 'modal',
    resolve: {
      lift: LiftDetailResolver,
      liftPermission: LiftPermissionResolver,
      temperatures: LiftTemperatureResolver
    }
  },
  {
    path: 'lift-consumption/:id',
    component: LiftConsumptionComponent,
    outlet: 'modal',
    resolve: {
      lift: LiftDetailResolver,
      liftPermission: LiftPermissionResolver
    }
  },
  {
    path: 'create-user',
    component: CreateUserComponent,
    outlet: 'modal',
    resolve: {
      companies: ComapnyLookupResolver
    }
  },
  {
    path: 'lift-module-detail/:id',
    component: LiftModuleDetailComponent,
    outlet: 'modal',
    resolve: {
      liftModule: LiftModuleDetailResolver
    }
  },
  {
    path: 'create-lift-module',
    component: CreateLiftModuleComponent,
    outlet: 'modal'
  },
  {
    path: 'create-lift-parameter-settings',
    component: CreateLiftParameterSettingsComponent,
    outlet: 'modal'
  },
  {
    path: 'create-lift-board-parameter-group/:boardId',
    component: CreateLiftBoardParameterGroupComponent,
    outlet: 'modal'
  },
  {
    path: 'lift-board-parameter-group-detail/:id',
    component: LiftBoardParameterGroupDetailComponent,
    outlet: 'modal',
    resolve: {
      liftBoardParameterGroup: LiftBoardParameterDetailResolver
    }
  },
  {
    path: 'create-lift-board-parameter/:boardId',
    component: CreateLiftBoardParameterComponent,
    outlet: 'modal',
    resolve: {
      parameters: LiftParameterSettingsListResolver,
      groups: LiftBoardGroupLookupResolver
    }
  },
  {
    path: 'lift-parameter-settings-detail/:id',
    component: LiftParameterSettingsDetailComponent,
    outlet: 'modal',
    resolve: {
      liftParameterDetail: LiftParameterSettingsDetailResolver
    }
  },
  {
    path: 'create-lookup/:type',
    component: CreateBasicLookupComponent,
    outlet: 'modal'
  },
  {
    path: 'lookup-detail/:type/:id',
    component: BasicLookupDetailComponent,
    outlet: 'modal',
    resolve: {
      data: LookupDetailResolver
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    UserModule,
    DashboardModule,
    CoreModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
